import { cn } from '@/lib/utils';
import { TrendingUp, TrendingDown } from 'lucide-react';

interface RecommendationBadgeProps {
  recommendation: 'YES' | 'NO';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function RecommendationBadge({ recommendation, size = 'md', className }: RecommendationBadgeProps) {
  const sizeClasses = {
    sm: 'px-2 py-1 text-xs',
    md: 'px-3 py-1.5 text-sm',
    lg: 'px-4 py-2 text-base',
  };

  const iconSizes = {
    sm: 12,
    md: 14,
    lg: 16,
  };

  const Icon = recommendation === 'YES' ? TrendingUp : TrendingDown;

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-md font-semibold',
        recommendation === 'YES' ? 'badge-yes' : 'badge-no',
        sizeClasses[size],
        className
      )}
    >
      <Icon size={iconSizes[size]} />
      {recommendation}
    </span>
  );
}
